<div class="slat-assessment-main-view-card-header">
  <app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
  <app-header-bar
    (routerLinkClick)="cancelAssessment()"
    [age]="_age"
    [dob]="_dateOfBirth"
    [showButton]="false"
    [showClientDetails]="_showClientDetails"
    [title]="_clientName"
    *ngIf="
      (_dateOfBirth != undefined || _dateOfBirth != null) &&
      (_age != undefined || _age != null)
    "
  ></app-header-bar>
</div>
<!-- Sub-Menu -->
<app-sub-menu
  [clientId]="_clientId"
  [totalReviews]="_totalReviews"
  [flipHasAccess]="_hasAccess.flipHasAccess"
  [reddiHasAccess]="_hasAccess.reddiHasAccess"
  [slatHasAccess]="_hasAccess.slatHasAccess"
  [showBackButton]="false"
  [showCancelDialog]="true"
  (navigateBackClick)="previousRoute()"
/>
<form [formGroup]="slatForm">
  <div class="slat-assessment-page-layout">
    <div class="slat-assessment-page-left">
      <div class="slat-assessment-content">
        <app-primary-card size="full" class="slat-assessment-primary-card">
          <div id="graph-header">
            <div id="header-title" class="mat-headline-1 header">
              {{ 'SLAT Entry' | translate }}
            </div>
            <p class="error-text error-message" *ngIf="_isError">
              *{{ 'SLAT Entry Error' | translate }}
            </p>
          </div>
          <div class="slat-assessment-info">
            <app-table-multi-header
              [dataSource]="dataSource"
              [isEdit]="!isAdd"
              [isView]="false"
              [isAdd]="isAdd"
              [isTableHeaderVisible]="false"
              (addClick)="openEditModal($event.element, $event.index)"
              (editClick)="openEditModal($event.element, $event.index)"
              class="app-slat-table"
            ></app-table-multi-header>
          </div>
        </app-primary-card>
      </div>
      <div class="slat-assessment-page-row-2">
        <div class="slat-response-cancel-button-container">
          <app-link-button
            (click)="cancelAssessment()"
            color="primary"
            size="slightly-wider"
          >
            {{ 'Cancel Assessment' | translate }}
          </app-link-button>
        </div>
      </div>
    </div>
    <div class="slat-assessment-page-right">
      <div class="slat-assessment-side-card">
        <app-side-card height="817" size="full">
          <H1>{{ 'SLAT' | translate }}</H1>
          <div class="section">
            <div class="title">{{ 'Data entered by' | translate }}</div>
            <div>
              <span class="text-highlight">{{ _presenterName }}</span>
            </div>
          </div>
          <div class="section">
            <span class="slat-assessment-date-picker">
              <app-datepicker
                [control]="slatForm.controls['assessmentDate']"
                [errorText]="getAssessmentErrorText()"
                date="{{ this.slatAssessmentDataDto?.assessmentDate }}"
                id="assessmentDate"
                [label]="'Assessment Date' | translate"
                required="true"
              />
            </span>
          </div>
          <div class="section">
            <app-text-input
              id="abbreviatedName"
              [label]="'Template Name' | translate"
              [placeholder]="'Template Name' | translate"
              [control]="slatForm.controls['abbreviatedName']"
              required="true"
              [isReadOnly]="true"
            />
          </div>
          <div class="section" formArrayName="considerations">
            <div class="title">{{ 'Considerations' | translate }}</div>
            <div *ngFor="let consideration of _considerations; let i = index">
              <input
                (change)="getConsiderations(i, $event)"
                [checked]="consideration.checked"
                [formControlName]="i"
                type="checkbox"
                aria-hidden="true"
              />
              <span class="text">{{ consideration.label | translate }}</span>
            </div>
          </div>

          <div class="notes-section">
            <div class="title">
              <textarea
                [formControl]="slatForm.controls['notes']"
                class="slat-assessment-notes-section"
                matInput
                [placeholder]="'Enter notes session' | translate"
              ></textarea>
            </div>
          </div>
        </app-side-card>
        <app-action-button
          (click)="finishSession()"
          [color]="'primary'"
          [kind]="'outline'"
          [size]="'full'"
          class="slat-assessment-finish-session-button"
        >
          {{ 'Finish Session' | translate }}
        </app-action-button>
      </div>
    </div>
  </div>
</form>
